module.exports = __webpack_public_path__ + "img/info-02-m.214c7719.png";